<template>
	<b-row>
		<b-col xl="9" sm="8">
			<definicion-compras :origin-id="$route.params.id" />
		</b-col>
		<b-col xl="3" sm="4">

			<b-card bg-variant="dark">
				<div slot="header">Descargables</div>
				<b-form-select class="mb-3" v-model="selected" :options="options"></b-form-select>

				<b-row>
					<b-col>
						<b-button variant="primary" class="btn-block" @click="tryDownloadExcel()">
							<i class="fa fa-download"></i>
							Excel
						</b-button>
					</b-col>
					<b-col>
						<b-button variant="warning" class="btn-block" @click="tryDownloadPDF()">
							<i class="fa fa-download"></i>
							PDF
						</b-button>
					</b-col>
				</b-row>
			</b-card>

			<auto-form title="Detalles" :origin-id="$route.params.id" origin="define/source/reportes_compras" />
		</b-col>
	</b-row>
</template>

<script>
import definicionCompras from "./DefinicionCompras.vue";
import axios from "axios";
import _ from "lodash";
import { downloadFile } from "@/utils.js"

export default {
	data() {
		return {
			selected: "@",
			catsAvailable: [],
			optionsBase: [{ value: "@", text: "TODAS LAS CATEGORÍAS" }],
		};
	},
	computed: {
		options() {
			let i = [];
			i.push(this.optionsBase[0]);
			_.forEach(_.sortBy(this.catsAvailable, ["label"]), (cat) => {
				i.push(cat);
			});
			return i;
		},
	},
	components: {
		definicionCompras,
	},
	methods: {
		loadCats() {
			axios.get("compras/getcats/" + this.$route.params.id).then((response) => {
				this.catsAvailable = response.data;
			});
		},
		tryDownloadExcel() {
			const uri = "compras/downloadexcel/" + this.$route.params.id + "/" + this.selected;
			downloadFile("reporte.csv", uri);
		},
		tryDownloadPDF() {
			const uri = "compras/downloadpdf/" + this.$route.params.id + "/" + this.selected + "/processFile";
			axios
				.get(uri)
				.then(response => {
					if (response.status) {
						var link = document.createElement("a");
						link.setAttribute("href", response.data);
						link.setAttribute("download", "reporte.pdf");
						link.setAttribute("target", "_blank");
						document.body.appendChild(link); // Required for FF
						link.click();
					}
				});
		},
	},
	mounted() {
		this.loadCats();
	},
};
</script>
